import { makeStyles } from 'tss-react/mui'
import CloseIcon from '@mui/icons-material/Close'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import genericStyles from 'styles/material-styles/genericStyles.js'
import _colors from '../../../styles/global/_colors'
import { WarningProps } from '../../../ts/interfaces/warningProps.interface'
import { ThemeType } from '../../../ts/types/theme.types'

const useStyles = makeStyles()((theme: ThemeType) => ({
  warning: {
    ...genericStyles.alertContainer,
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.warning}`,
    color: `${_colors.warningDark}`,
    border: `1.5px solid ${_colors.warning}`,
  },
  icon: {
    color: `${_colors.yellow}`,
  },
  close: {
    marginLeft: '15px',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  content: {
    padding: '0 8px 0 8px',
  },
  okButton: {
    textDecoration: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}))

const Warning = ({ onClose, description, onOk, okButtonLabel }: WarningProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.warning}>
      <ReportProblemOutlinedIcon className={classes.icon} />
      <div className={classes.content}>{description}</div>
      {onOk && (
        <Button onClick={onOk} color="inherit" size="small" className={classes.okButton}>
          {okButtonLabel ?? 'OK'}
        </Button>
      )}
      <IconButton
        key="close"
        aria-label="Close"
        color="inherit"
        className={classes.close}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default Warning
